module.exports = __webpack_public_path__ + "img/logo-circ.99358940.png";